// Captures utm_* query params so they survive from the entry page (landing
// page or product page reached directly from an ad) through client-side
// navigation to wherever a lead form is eventually submitted, since React
// Router navigation doesn't carry the original query string along with it.
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const STORAGE_KEY = 'dynalog_utm_params';

const readStored = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

// Call once per page load (e.g. at the app root) — reads utm_* params from
// the given query string and merges any present ones into sessionStorage.
// Params already stored from an earlier page in this session are kept when
// the current page doesn't repeat them (first-touch), and a call from a page
// carrying UTM params of its own — e.g. a product URL that itself came from a
// campaign link — provides last-touch fields.
export const captureUtmParams = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  const found = {};
  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) found[key] = value;
  });
  if (Object.keys(found).length === 0) return;

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readStored(), ...found }));
  } catch {
    // sessionStorage unavailable (private mode, etc.) — UTM capture is best-effort.
  }
};

// Returns { utm_source, utm_medium, utm_campaign, utm_term, utm_content },
// each null when never captured this session — ready to spread into a lead payload.
export const getUtmParams = () => {
  const stored = readStored();
  return UTM_KEYS.reduce((acc, key) => {
    acc[key] = stored[key] || null;
    return acc;
  }, {});
};
